import {AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {EventosTablaInterface} from '../../interfaces/eventos-tabla.interface';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import * as swalFunctions from '../../data/sweet-alert';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Reglux} from '../../constants/reglux';
import {NotasService} from '../../services/notas.service';
import {Constants} from '../../constants/constants';

@Component({
  selector: 'app-notas',
  templateUrl: './notas.component.html',
  styleUrls: ['./notas.component.scss']
})
export class NotasComponent implements OnInit, AfterViewInit {

  @ViewChild('modalNotas') modal: ElementRef;
  @Output() emitter: EventEmitter<EventosTablaInterface> = new EventEmitter<EventosTablaInterface>();
  @Input() notas: any;
  evento: EventosTablaInterface;

  // Formulario
  nota: FormGroup;

  // Variables
  guardado = false;
  swal = swalFunctions;
  descripcion: string;

  constructor(private formBuilder: FormBuilder,
              private modalService: NgbModal,
              private _notas: NotasService,
              private cd: ChangeDetectorRef,
              private constants: Constants) {
  }

  ngOnInit(): void {
    this.initForm();
  }

  ngAfterViewInit(): void {
    this.modalService.open(this.modal, {
      backdrop: 'static',
      keyboard: false
    });
    this.descripcion = this.notas.descripcion;
  }

  initForm(): void {
    this.nota = this.formBuilder.group({
      id: [this.notas.id, [Validators.required]],
      tabla: [this.notas.tabla, [Validators.required]],
      descripcion: [this.notas.descripcion, [Validators.required]],
      notas: [this.notas.notas, [Validators.required, Validators.maxLength(255)]]
    });
  }

  emit(accion: string): void {
    this.evento = {
      accion: accion
    }
    this.emitter.emit(this.evento);
  }

  validateField(campo: string, codigoError: string): boolean {
    return this.nota.get(campo).hasError(codigoError);
  }

  saveOrUpdateRecord(): boolean {
    this.guardado = true;

    // Post

    this._notas.postNota(this.nota.value).subscribe(res => {
      if (res != null && res != false) {
        this.swal.TypeSuccess('Nota guardada correctamente', 'Verifique la información');
        this.emit(this.constants.ACTUALIZAR_TABLA);
        this.modalService.dismissAll();
      } else {
        this.swal.TypeError('Algo salió mal', 'Intente nuevamente.');
      }
      this.initForm();
      this.guardado = false;
      this.cd.markForCheck();
    }, error => {
      this.guardado = false;
      this.swal.TypeErrorDetails(error.error.message, error.error.trace);
    });

    return true;
  }

}
